<template>
  <!-- 统计报表 -->
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="供应商统计">供应商统计</el-tab-pane>
      <el-tab-pane label="客户统计">客户统计</el-tab-pane>
      <el-tab-pane label="商品采购统计">商品采购统计</el-tab-pane>
      <el-tab-pane label="商品销售统计">商品销售统计</el-tab-pane>
      <el-tab-pane label="日销售统计">日销售统计</el-tab-pane>
      <el-tab-pane label="月销售统计">月销售统计</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "SlmsReport",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>